import { baseElements, breakpoints } from '../helpers/constants';
import SlideMenu from '../vendors/menu/SlideMenu';
import scroll from './smooth-scroll';
const {
  $header
} = baseElements;
const $menuElement = document.querySelector('.slide-menu');
const $navItems = $header.querySelectorAll('[data-navigate]');
let currentTransformValue = 0;
let startPoint = null;
let {
  offsetHeight
} = $header;
let menu;
const scrollUp = () => {
  currentTransformValue = 0;
  startPoint = null;
  $header.classList.add('__up');
  $header.classList.remove('__down');
  $header.style.transform = 'translate3d(0, 0, 0)';
};
const scrollDown = scrollPos => {
  if (!startPoint) startPoint = scrollPos;
  if (currentTransformValue < offsetHeight) {
    currentTransformValue = scrollPos - startPoint;
    $header.classList.remove('__up');
    $header.classList.add('__down');
    $header.style.transform = `translate3d(0, -${currentTransformValue}px, 0)`;
  }
};
const onScroll = (scrollPos, direction) => {
  $header.classList.toggle('__no-shadow', direction === 1 && scrollPos < offsetHeight);
  $header.classList.toggle('__top', scrollPos === 0);
  $header.classList.toggle('__beyond-top', currentTransformValue >= offsetHeight);
};
const header = () => {
  scroll.init(scrollUp, scrollDown, onScroll);
  if ($menuElement) {
    const createMenu = () => {
      menu = new SlideMenu($menuElement, {
        position: 'left',
        saveMenuState: false,
        backLinkTitle: 'current',
        slideContent: false,
        parentTitle: false,
        backLinkBefore: '<span class="arrow-back"></span>',
        submenuLinkAfter: '<span class="arrow-forward"></span>',
        subMegaMenuLevel: window.innerWidth > breakpoints.xl ? 2 : null,
        onOpen: () => scroll.scrollDisable(),
        onClose: () => scroll.scrollEnable()
      });
    };
    createMenu();
    const setLevel = e => {
      if (window.innerWidth <= breakpoints.xl) return;
      $menuElement.dataset.level = e.type === 'sm.back' ? 0 : menu.level;
    };
    $navItems.forEach($link => {
      $link.addEventListener('click', e => {
        const linkId = e.target.dataset.navigate;
        const $activeLink = $menuElement.querySelector(`#${linkId}`).nextElementSibling;
        if ($activeLink) {
          e.preventDefault();
          menu.open();
          menu.navigateTo($activeLink);
        }
      });
    });
    document.addEventListener('click', e => {
      if (!$menuElement.contains(e.target) && !$header.contains(e.target)) {
        menu.close();
      }
    });
    $menuElement.addEventListener('sm.open', setLevel);
    $menuElement.addEventListener('sm.forward-after', setLevel);
    $menuElement.addEventListener('sm.navigate-after', setLevel);
    $menuElement.addEventListener('sm.back', setLevel);
  }
  window.addEventListener('windowResize', () => {
    offsetHeight = $header.offsetHeight;
  });
};
export default header;